export default __webpack_public_path__ + "_/shared_modules/baui-ui/components/LoanAmountFilter/images/minus-stainless-500-976110bc794539b48b56576b34056221.svg";